import axios from "axios";

const instance = axios.create({
  baseURL: "https://burgerbuilder-6dd0d.firebaseio.com/",
});

export default instance;



// WEBPACK FOOTER //
// ./src/axios-orders.js